var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CreditBudgetExcelModal", { on: { success: _vm.successExcelImport } }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { id: "confirm-edit-modal" + _vm.unique },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function() {
                return [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("list.editConfirm")) + "\n    "
                  )
                ]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right ml-2",
                      attrs: { size: "sm", variant: "outline-danger" },
                      on: {
                        click: function($event) {
                          return _vm.$bvModal.hide(
                            "confirm-edit-modal" + _vm.unique
                          )
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("insert.cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right ml-2",
                      attrs: { size: "sm", variant: "success" },
                      on: {
                        click: function($event) {
                          return _vm.editItem()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("insert.okay")))]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("list.rowEditConfirm")) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { id: "warning-edit-modal" },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function() {
                return [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("list.editConfirm")) + "\n    "
                  )
                ]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right ml-2",
                      attrs: { size: "sm", variant: "success" },
                      on: {
                        click: function($event) {
                          return _vm.$bvModal.hide("warning-edit-modal")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("insert.okay")))]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("list.rowEditWarning")) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { id: "confirm-delete-modal" + _vm.unique },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function() {
                return [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("list.deleteConfirm")) + "\n    "
                  )
                ]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right ml-2",
                      attrs: { size: "sm", variant: "outline-danger" },
                      on: {
                        click: function($event) {
                          return _vm.$bvModal.hide(
                            "confirm-delete-modal" + _vm.unique
                          )
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("insert.cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right ml-2",
                      attrs: { size: "sm", variant: "success" },
                      on: {
                        click: function($event) {
                          return _vm.removeItem()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("insert.okay")))]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("list.rowDeleteConfirm")) + "\n    ")]
      ),
      _vm._v(" "),
      _vm.editable
        ? _c(
            "b-row",
            [
              _vm._l(
                _vm.items
                  ? _vm.items.filter(function(i) {
                      return i.visible === true
                    })
                  : [],
                function(item, i) {
                  return _c(
                    "NextFormGroup",
                    {
                      key: i,
                      attrs: {
                        title: _vm.$t(item.label),
                        required: _vm.isRequired(item),
                        error: _vm.isRequired(item)
                          ? _vm.$v.form[item.modelProperty]
                          : {}
                      }
                    },
                    [
                      item.type === "Autocomplete"
                        ? _c("NextDropdownUnitSet", {
                            attrs: {
                              url: item.url,
                              searchable: true,
                              disabled: _vm.isDisabled(item),
                              "dynamic-and-condition": item.dynamicAndCondition,
                              "dynamic-request": item.dynamicRequest,
                              label: item.labelProperty
                                ? item.labelProperty
                                : "Description1",
                              "custom-option": item.customOption,
                              "is-customer": item.isCustomer,
                              "or-condition-fields": item.orConditionFields,
                              "is-employee": item.isEmployee,
                              "is-vehicle": item.isVehicle
                            },
                            on: {
                              input: function($event) {
                                return _vm.additionalSearchType(
                                  item.id,
                                  item.modelProperty,
                                  $event,
                                  item.valueProperty
                                )
                              }
                            },
                            model: {
                              value: _vm.model[item.modelProperty],
                              callback: function($$v) {
                                _vm.$set(_vm.model, item.modelProperty, $$v)
                              },
                              expression: "model[item.modelProperty]"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === "DropdownUnitSet" && !item.parentId
                        ? _c("NextDropdownUnitSet", {
                            attrs: {
                              onAfter: item.onAfter,
                              source: item.source,
                              url: item.url,
                              label: item.labelProperty
                                ? item.labelProperty
                                : "Description1",
                              disabled: _vm.isDisabled(item),
                              "dynamic-and-condition": item.dynamicAndCondition,
                              "dynamic-request": item.dynamicRequest,
                              filter: item.filter,
                              "custom-option": item.customOption,
                              "is-prefix": item.isPrefix,
                              "page-count": item.pageCount
                            },
                            on: {
                              input: function($event) {
                                return _vm.additionalSearchType(
                                  item.id,
                                  item.modelProperty,
                                  $event,
                                  item.valueProperty
                                )
                              }
                            },
                            model: {
                              value: _vm.model[item.modelProperty],
                              callback: function($$v) {
                                _vm.$set(_vm.model, item.modelProperty, $$v)
                              },
                              expression: "model[item.modelProperty]"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === "DropdownUnitSet" && item.parentId
                        ? _c("NextDropdownUnitSet", {
                            attrs: {
                              source: _vm.source[item.modelProperty],
                              label: item.labelProperty
                                ? item.labelProperty
                                : "Description1",
                              disabled: _vm.isDisabled(item),
                              "dynamic-and-condition": item.dynamicAndCondition,
                              "dynamic-request": item.dynamicRequest,
                              "page-count": item.pageCount
                            },
                            on: {
                              input: function($event) {
                                return _vm.additionalSearchType(
                                  item.id,
                                  item.modelProperty,
                                  $event,
                                  item.valueProperty
                                )
                              }
                            },
                            model: {
                              value: _vm.model[item.modelProperty],
                              callback: function($$v) {
                                _vm.$set(_vm.model, item.modelProperty, $$v)
                              },
                              expression: "model[item.modelProperty]"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === "Lookup"
                        ? _c("NextDropdownUnitSet", {
                            attrs: {
                              "lookup-key": item.url,
                              disabled: _vm.isDisabled(item),
                              "get-lookup": true,
                              label: item.labelProperty
                                ? item.labelProperty
                                : "Label",
                              filter: item.filter
                            },
                            on: {
                              input: function($event) {
                                return _vm.additionalSearchType(
                                  item.id,
                                  item.modelProperty,
                                  $event,
                                  item.valueProperty
                                )
                              }
                            },
                            model: {
                              value: _vm.model[item.modelProperty],
                              callback: function($$v) {
                                _vm.$set(_vm.model, item.modelProperty, $$v)
                              },
                              expression: "model[item.modelProperty]"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === "Label"
                        ? _c("NextInput", {
                            attrs: {
                              type: item.inputType,
                              readonly: _vm.isDisabled(item)
                            },
                            model: {
                              value: _vm.label[item.modelProperty],
                              callback: function($$v) {
                                _vm.$set(_vm.label, item.modelProperty, $$v)
                              },
                              expression: "label[item.modelProperty]"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === "Text"
                        ? _c("NextInput", {
                            attrs: {
                              type: item.inputType,
                              readonly: _vm.isDisabled(item),
                              maxLength: item.maxLength,
                              minLength: item.minLength,
                              oninput: item.isPostCode
                                ? _vm.postCodeControl
                                : _vm.maxLengthControl
                            },
                            on: {
                              input: function($event) {
                                return _vm.enterValue(item.id, $event)
                              }
                            },
                            model: {
                              value: _vm.form[item.modelProperty],
                              callback: function($$v) {
                                _vm.$set(_vm.form, item.modelProperty, $$v)
                              },
                              expression: "form[item.modelProperty]"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === "NumberDotOrComma"
                        ? _c("NextInput", {
                            attrs: {
                              type: item.inputType,
                              readonly: _vm.isDisabled(item),
                              maxLength: item.maxLength,
                              minLength: item.minLength,
                              oninput: item.isPostCode
                                ? _vm.postCodeControl
                                : _vm.maxLengthControl
                            },
                            on: {
                              input: function($event) {
                                return _vm.enterValue(item.id, $event)
                              },
                              keypress: function($event) {
                                _vm.onlyForCurrencyDotOrComma($event)
                                _vm.keypress($event)
                              }
                            },
                            model: {
                              value: _vm.form[item.modelProperty],
                              callback: function($$v) {
                                _vm.$set(_vm.form, item.modelProperty, $$v)
                              },
                              expression: "form[item.modelProperty]"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === "Check"
                        ? _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled: _vm.isDisabled(item)
                            },
                            model: {
                              value: _vm.form[item.modelProperty],
                              callback: function($$v) {
                                _vm.$set(_vm.form, item.modelProperty, $$v)
                              },
                              expression: "form[item.modelProperty]"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === "Radio"
                        ? _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              radio: "",
                              disabled: _vm.isDisabled(item)
                            },
                            model: {
                              value: _vm.form[item.modelProperty],
                              callback: function($$v) {
                                _vm.$set(_vm.form, item.modelProperty, $$v)
                              },
                              expression: "form[item.modelProperty]"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.type === "Date"
                        ? _c("NextDatePicker", {
                            attrs: { disabled: _vm.isDisabled(item) },
                            model: {
                              value: _vm.form[item.modelProperty],
                              callback: function($$v) {
                                _vm.$set(_vm.form, item.modelProperty, $$v)
                              },
                              expression: "form[item.modelProperty]"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                }
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", md: "2" } },
                [
                  _c(
                    "b-form-group",
                    [
                      !_vm.isUpdated && _vm.showAddButton
                        ? _c("AddDetailButton", {
                            nativeOn: {
                              click: function($event) {
                                return _vm.addItems()
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isUpdated
                        ? _c(
                            "b-button",
                            {
                              staticClass: "mt-4",
                              attrs: { size: "sm", variant: "success" },
                              on: {
                                click: function($event) {
                                  return _vm.addItems()
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fa fa-pencil-alt" }),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("insert.edit")) +
                                  "\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isExcelImport
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-modal",
                                  rawName:
                                    "v-b-modal.credit-budget-excel-modal",
                                  modifiers: {
                                    "credit-budget-excel-modal": true
                                  }
                                }
                              ],
                              staticClass: "mt-4",
                              attrs: { size: "sm", variant: "success" }
                            },
                            [
                              _c("i", { staticClass: "fas fa-file-pdf" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("insert.creditBudget.uploadExcel")
                                  )
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm._t("grid")
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-table", {
            staticClass: "detail-panel-table",
            attrs: {
              id: _vm.id,
              fields: _vm.fields,
              items: _vm.filteredValues
                ? _vm.filteredValues.filter(function(i) {
                    return i.RecordState !== 4
                  })
                : [],
              bordered: "",
              responsive: "",
              "current-page": _vm.currentPage,
              "per-page": 10,
              small: ""
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "head()",
                  fn: function(data) {
                    return [
                      _c("div", [_vm._v(_vm._s(_vm.$t(data.label)))]),
                      _vm._v(" "),
                      _vm.getItemSearchable(data.column)
                        ? _c("NextInput", {
                            on: {
                              input: function($event) {
                                return _vm.filterList($event, data.column)
                              }
                            },
                            model: {
                              value: _vm.searchableItems[data.column],
                              callback: function($$v) {
                                _vm.$set(_vm.searchableItems, data.column, $$v)
                              },
                              expression: "searchableItems[data.column]"
                            }
                          })
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "cell()",
                  fn: function(data) {
                    return [
                      _c("div", {
                        staticClass: "detail-panel-data-view",
                        domProps: {
                          innerHTML: _vm._s(_vm.formatValue(data.value))
                        }
                      })
                    ]
                  }
                },
                {
                  key: "cell(operations)",
                  fn: function(data) {
                    return [
                      _vm.showEdit && _vm.editable
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.bottom",
                                  modifiers: { hover: true, bottom: true }
                                }
                              ],
                              staticClass:
                                "btn mt-1 mr-1 btn-warning operations-button",
                              attrs: { title: _vm.$t("list.edit") },
                              on: {
                                click: function($event) {
                                  _vm.$bvModal.show(
                                    "confirm-edit-modal" + _vm.unique
                                  )
                                  _vm.selectedItem = data.item
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-pencil-alt" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showWarning && _vm.editable
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.bottom",
                                  modifiers: { hover: true, bottom: true }
                                }
                              ],
                              staticClass:
                                "btn mt-1 mr-1 btn-warning operations-button",
                              attrs: { title: _vm.$t("list.edit") },
                              on: {
                                click: function($event) {
                                  return _vm.$bvModal.show("warning-edit-modal")
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-pencil-alt" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.editable
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.bottom",
                                  modifiers: { hover: true, bottom: true }
                                }
                              ],
                              staticClass:
                                "btn mt-1 mr-1 btn-danger operations-button",
                              attrs: {
                                title: _vm.$t("list.delete"),
                                type: "button"
                              },
                              on: {
                                click: function($event) {
                                  _vm.$bvModal.show(
                                    "confirm-delete-modal" + _vm.unique
                                  )
                                  _vm.selectedItem = data.item
                                }
                              }
                            },
                            [_c("i", { staticClass: "far fa-trash-alt" })]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.getDetail
                        ? _c("i", {
                            staticClass: "ml-3 fa fa-arrow-down text-success",
                            attrs: { title: _vm.$t("get.detail") },
                            on: {
                              click: function($event) {
                                return _vm.getDetail(data.item)
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.detailButtons, function(detail, i) {
                        return _c(
                          "b-button",
                          {
                            key: i,
                            staticClass:
                              "btn mt-1 mr-1 btn-success operations-button",
                            attrs: { title: detail.title },
                            on: {
                              click: function($event) {
                                return detail.getDetail(data.item, data.index)
                              }
                            }
                          },
                          [_c("i", { class: "text-light " + detail.icon })]
                        )
                      })
                    ]
                  }
                },
                {
                  key: "cell(show_details)",
                  fn: function(row) {
                    return [
                      _c(
                        "div",
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-2",
                              attrs: { size: "sm", variant: "success" },
                              on: { click: row.toggleDetails }
                            },
                            [
                              _c("i", { staticClass: "fa fa-arrow-down" }),
                              _vm._v(
                                _vm._s(_vm.detailButtonText) + "\n          "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  }
                },
                _vm.hasDetail
                  ? {
                      key: "row-details",
                      fn: function() {
                        return [
                          _c(
                            "div",
                            { staticClass: "p-4" },
                            [
                              _c("h2", [_vm._t("title")], 2),
                              _vm._v(" "),
                              _c("hr"),
                              _vm._v(" "),
                              _vm._t("body")
                            ],
                            2
                          )
                        ]
                      },
                      proxy: true
                    }
                  : null
              ],
              null,
              true
            )
          }),
          _vm._v(" "),
          _c("b-pagination", {
            attrs: {
              "total-rows": _vm.filteredValues ? _vm.filteredValues.length : 0,
              "per-page": 10,
              "aria-controls": _vm.id
            },
            model: {
              value: _vm.currentPage,
              callback: function($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1344b00e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1344b00e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NextDetailPanelUnitSet.vue
// module id = null
// module chunks = 